import React, { Component } from 'react';
import { connect } from 'react-redux';
import SellerTable from './Components/SellerTable';
import NavBar from '../../../_components/common/Navbar';
import Footer from '../../../_components/common/Footer';
import { sellerActions } from '../../../_actions';
import './index.css';
import { CommonBreadCrumb } from '../../../_components/common/CommonBreadCrumb';


class Sellers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSwal: true
        };
    }
    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(sellerActions.getSellers());
    }

    render() {

        const { loading, sellers } = this.props;
        return (
            <div className="animation-fade-in">
                <NavBar />

                <div className="container custom-container my-5" >

                    <div>
                        <CommonBreadCrumb
                            data={[
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: '',
                                    name: 'SELLERS'
                                }
                            ]}
                        />
                    </div>

                    <SellerTable
                        heading="Sellers"
                        sellers={sellers}
                        loading={loading}
                    />
                </div>
                <Footer />
            </div>
        );


    }

}

function mapStateToProps(state) {

    const { alert } = state;
    const loading = state.seller.loading;
    const error = state.seller.error;
    const sellers = (!loading && !error) ? state.seller.seller.data.seller_list : '';

    return {
        alert,
        loading,
        sellers,
        error
    };
}

export default connect(mapStateToProps)(Sellers);


// WEBPACK FOOTER //
// ./src/_pages/Admin/Sellers/index.jsx